import { render, staticRenderFns } from "./TarjetaEntrada.vue?vue&type=template&id=36213412&scoped=true"
import script from "./TarjetaEntrada.vue?vue&type=script&lang=js"
export * from "./TarjetaEntrada.vue?vue&type=script&lang=js"
import style0 from "./TarjetaEntrada.vue?vue&type=style&index=0&id=36213412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36213412",
  null
  
)

export default component.exports